import $ from 'jquery'
import openModal from '/lib/openModal'

export default function initPopup(){
  $(document).on('click', '.js-open-modal', e => { 
    e.preventDefault()
    openModal(e) 
  } )
}
